import EvaluationsToRateView from "../../features/performance/EvaluationsToRateView";

const EvaluationsToRatePage = () => <EvaluationsToRateView />;

export default EvaluationsToRatePage;
